const user = {
  id: null,
  password: null,
  currentPassword: null
}

export default () => Object.assign({}, user)
